export enum AccessEvent {
  ACCESS_SESSION_UPDATED = 'accessSessionUpdated',
  ACCESS_SESSION_PUBLISHED = 'accessSessionPublished',
  LOGGED_IN = 'loggedIn',
  ANONYMOUS_INIT = 'anonymousInit',
  NEXT_CLICKED = 'nextClicked',
  NEXT_CLICKED_COMPLETE = 'nextClickedComplete',
  SUBMIT_PAYLOAD = 'submitPayload',
  NAVBAR_CLICKED = 'navbarClicked',
  LOCATION_CHANGE = 'locationChange',
  RESULTS_EVENT = 'resultsEvent',
}
